import { forwardRef } from "react";

const AuthInput = forwardRef(({ 
  icon: Icon, 
  type = "text", 
  placeholder, 
  value, 
  onChange, 
  error, 
  className = "", 
  ...props 
}, ref) => {
  return (
    <div className="relative group">
      <div className="relative rounded-xl p-[1px] bg-gradient-to-br from-emerald-400/30 via-transparent to-emerald-400/30 transition-all duration-300 group-hover:from-emerald-400/50 group-hover:to-emerald-400/50 group-focus-within:from-emerald-500/60 group-focus-within:to-emerald-500/60">
        <div className={`flex items-center gap-3 rounded-[0.95rem] bg-white/95 px-4 py-3 ring-1 ring-gray-200/50 shadow-sm backdrop-blur-md transition-all duration-300 group-hover:ring-emerald-300/60 group-hover:shadow-md group-focus-within:ring-emerald-400/80 group-focus-within:shadow-lg group-focus-within:bg-white ${error ? 'ring-red-300/60' : ''} ${className}`}>
          {Icon && (
            <Icon size={18} className="text-emerald-600 transition-colors duration-300 group-focus-within:text-emerald-700" />
          )}
          <input
            ref={ref}
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className="w-full text-sm font-medium bg-transparent border-0 transition-colors duration-300 outline-none focus:outline-none focus:ring-0 focus:border-0 focus:shadow-none placeholder:text-gray-400 placeholder:font-normal focus:text-gray-900"
            {...props}
          />
        </div>
      </div>
      {error && (
        <p className="mt-1 text-xs text-red-500">{error}</p>
      )}
    </div>
  );
});

AuthInput.displayName = "AuthInput";

export default AuthInput;
